module.exports = __webpack_public_path__ + "static/langojango-portuguese-language-phrasebook-7fa7dc03a4ed89effbe34fc2c2c10ded.png";